import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from './property.model';
import {Guest} from "./guests.model";

/**
 * @class Feedback
 * @property {number} id
 */
export class Feedback extends TranslatableModel {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }

    setGuest(value) {

        return value && (value instanceof Guest ? value : new Guest(value));
    }

    static get AVG_BAD() {

        return {
            key: 'bad',
            start: 1,
            end: 3.9,
            value: 'BAD'
        };
    }

    static get AVG_GOOD() {

        return {
            key: 'good',
            start: 4,
            end: 7.9,
            value: 'GOOD'
        };
    }

    static get AVG_SUPERB() {

        return {
            key: 'super',
            start: 8,
            end: 10,
            value: 'SUPERB'
        };
    }

    static get AVG() {

        return [
            this.AVG_BAD,
            this.AVG_GOOD,
            this.AVG_SUPERB,
        ];
    }
}

AccessorsMutatorsDecorator('id', ...Feedback.translatableAttributesWithLanguageAliases,
    'property_id',
    'guest_id',
    'reservation_id',
    'food',
    'cleanliness',
    'location',
    'facilities',
    'staff',
    'money',
    'internet',
    'feedback',
    'avg_count',
    'status',
    'ident',
    'created_at',
    'guest',
    'count',
    'token',
    )(Feedback);



// WEBPACK FOOTER //
// ./src/pms-api/models/feedback.model.js